module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/207/assets/images/4c1f7a71fb6bce7b923771e001fe40fd.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_cards.svg
// module id = zDW0
// module chunks = 1